/* http://keith-wood.name/countdown.html
 * Czech initialisation for the jQuery countdown extension
 * Written by Roman Chlebec (creamd@c64.sk) (2008) */
(function($) {
	'use strict';
	$.countdown.regionalOptions.cs = {
		labels: ['Roků','Měsíců','Týdnů','dní','hod','min','sec'],
		labels1: ['Rok','Měsíc','Týden','den','hod','min','sec'],
		labels2: ['Roky','Měsíce','Týdny','dny','hod','min','sec'],
		compactLabels: ['r','m','t','d'],
		whichLabels: function(amount) {
			return (amount === 1 ? 1 : (amount >= 2 && amount <= 4 ? 2 : 0));
		},
		digits: ['0','1','2','3','4','5','6','7','8','9'],
		timeSeparator: ':',
		isRTL: false
	};
	$.countdown.setDefaults($.countdown.regionalOptions.cs);
})(jQuery);
